import { GetCourseDeletabilityResponse } from '../../../../api-service/clients';

export function getCannotBeDeletedReason({ hasLessons, hasCourseEnrollments }: GetCourseDeletabilityResponse) {
  const blockers = [hasLessons && 'lektioner', hasCourseEnrollments && 'tilknyttede fremmødeforløb'].filter(Boolean);
  if (!blockers.length) {
    return undefined;
  }

  return `Holdet kan ikke slettes, fordi det har ${blockers.join(' og ')}`;
}
